var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._b({staticClass:"home-section"},'section',_vm.initData,false),[_c('HomeWelcome'),_c('HomeSlide'),_c('HomeOurCompany'),_c('HomeServices',{attrs:{"to":this.to}}),_c('VueSlickCarouselComp'),_c('SliderVideosHome'),_c('TestimonialsSection',{attrs:{"to":this.to}}),_c('PresentSection'),_c('LocationsSection'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }